(function () {
  'use strict';

  // Verified directly against the live collection list - handles follow a
  // consistent "device-name-cases" pattern.
  var BRANDS = {
    iphone: {
      label: 'iPhone',
      models: [
        { label: 'iPhone 18 Pro Max', handle: 'iphone-18-pro-max-cases' },
        { label: 'iPhone 18 Pro', handle: 'iphone-18-pro-cases' },
        { label: 'iPhone 17 Pro Max', handle: 'iphone-17-pro-max-cases' },
        { label: 'iPhone 17 Pro', handle: 'iphone-17-pro-cases' },
        { label: 'iPhone Air', handle: 'iphone-air-cases' },
        { label: 'iPhone 17', handle: 'iphone-17-cases' },
        { label: 'iPhone 16 Pro Max', handle: 'iphone-16-pro-max-cases' },
        { label: 'iPhone 16 Pro', handle: 'iphone-16-pro-cases' },
        { label: 'iPhone 16 Plus', handle: 'iphone-16-plus-cases' },
        { label: 'iPhone 16', handle: 'iphone-16-cases' },
        { label: 'iPhone 15 Pro Max', handle: 'iphone-15-pro-max-cases' },
        { label: 'iPhone 15 Pro', handle: 'iphone-15-pro-cases' },
        { label: 'iPhone 15 Plus', handle: 'iphone-15-plus-cases' },
        { label: 'iPhone 15', handle: 'iphone-15-cases' },
        { label: 'iPhone 14 Pro Max', handle: 'iphone-14-pro-max-cases' },
        { label: 'iPhone 14 Pro', handle: 'iphone-14-pro-cases' },
        { label: 'iPhone 14 Plus', handle: 'iphone-14-plus-cases' },
        { label: 'iPhone 14', handle: 'iphone-14-cases' },
        { label: 'iPhone 13 Pro Max', handle: 'iphone-13-pro-max-cases' },
        { label: 'iPhone 13 Pro', handle: 'iphone-13-pro-cases' },
        { label: 'iPhone 13', handle: 'iphone-13-cases' },
        { label: 'iPhone 13 Mini', handle: 'iphone-13-mini-cases' }
      ]
    },
    samsung: {
      label: 'Samsung Galaxy',
      models: [
        { label: 'Samsung Galaxy S26 Ultra', handle: 'samsung-galaxy-s26-ultra-cases' },
        { label: 'Samsung Galaxy S26 Plus', handle: 'samsung-galaxy-s26-plus-cases' },
        { label: 'Samsung Galaxy S26', handle: 'samsung-galaxy-s26-cases' },
        { label: 'Samsung Galaxy S25 Ultra', handle: 'samsung-galaxy-s25-ultra-cases' },
        { label: 'Samsung Galaxy S25 Plus', handle: 'samsung-galaxy-s25-plus-cases' },
        { label: 'Samsung Galaxy S25', handle: 'samsung-galaxy-s25-cases' },
        { label: 'Samsung Galaxy S24 Ultra', handle: 'samsung-galaxy-s24-ultra-cases' },
        { label: 'Samsung Galaxy S24 Plus', handle: 'samsung-galaxy-s24-plus-cases' },
        { label: 'Samsung Galaxy S24', handle: 'samsung-galaxy-s24-cases' },
        { label: 'Samsung Galaxy S23 Ultra', handle: 'samsung-galaxy-s23-ultra-cases' },
        { label: 'Samsung Galaxy S23 Plus', handle: 'samsung-galaxy-s23-plus-cases' },
        { label: 'Samsung Galaxy S23', handle: 'samsung-galaxy-s23-cases' }
      ]
    },
    zflip: {
      label: 'Galaxy Z Flip',
      models: [
        { label: 'Galaxy Z Flip 8', handle: 'samsung-galaxy-z-flip-8-cases' },
        { label: 'Galaxy Z Flip 7', handle: 'samsung-galaxy-z-flip-7-cases' },
        { label: 'Galaxy Z Flip 6', handle: 'samsung-galaxy-z-flip-6-cases' },
        { label: 'Galaxy Z Flip 5', handle: 'samsung-galaxy-z-flip-5-cases' },
        { label: 'Galaxy Z Flip 4', handle: 'samsung-galaxy-z-flip-4-cases' }
      ]
    }
  };

  function populateModels(container, brandKey, includePlaceholder) {
    var modelSelect = container.querySelector('[data-model-select]');
    var brand = BRANDS[brandKey];
    if (!brand) return;

    var optionsHtml = brand.models.map(function (m) {
      return '<option value="' + m.handle + '">' + m.label + '</option>';
    }).join('');

    if (includePlaceholder) {
      optionsHtml = '<option value="" disabled selected>Choose model\u2026</option>' + optionsHtml;
    }

    modelSelect.innerHTML = optionsHtml;
  }

  function getGenderFilterSuffix() {
    var params = new URLSearchParams(window.location.search);
    var view = params.get('view') || '';
    var isMen = view.indexOf('men') !== -1 || sessionStorage.getItem('gender') === 'men';
    var filterValue = isMen ? 'male,unisex' : 'female,unisex';
    return '?filter.p.m.custom.product_gender_context=' + filterValue;
  }

  function init(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var brandSelect = container.querySelector('[data-brand-select]');
    var modelSelect = container.querySelector('[data-model-select]');

    // Try to detect the current brand/model from the page URL so the
    // selector reflects whichever collection the visitor is already on.
    var pathHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var detectedBrandKey = 'iphone';
    Object.keys(BRANDS).some(function (brandKey) {
      var found = BRANDS[brandKey].models.some(function (m) { return m.handle === pathHandle; });
      if (found) {
        detectedBrandKey = brandKey;
        return true;
      }
      return false;
    });

    brandSelect.value = detectedBrandKey;
    populateModels(container, detectedBrandKey, false);
    if (pathHandle) {
      var matchingOption = Array.prototype.find.call(modelSelect.options, function (o) { return o.value === pathHandle; });
      if (matchingOption) modelSelect.value = pathHandle;
    }

    brandSelect.addEventListener('change', function () {
      populateModels(container, brandSelect.value, true);
    });

    modelSelect.addEventListener('change', function () {
      if (modelSelect.value) {
        window.location.href = '/collections/' + modelSelect.value + getGenderFilterSuffix();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="DeviceSelector-"]').forEach(function (el) {
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();